import { render } from "./claimApproval.vue?vue&type=template&id=6626612d&scoped=true"
import script from "./claimApproval.vue?vue&type=script&lang=js"
export * from "./claimApproval.vue?vue&type=script&lang=js"

import "./claimApproval.vue?vue&type=style&index=0&id=6626612d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6626612d"]])

export default __exports__